export default {"src":"/_next/static/media/logo_inovando_completa.96bd2486.svg","height":46,"width":232};